import React, { useState, useEffect, useRef } from 'react';
import { LuLink2 } from "react-icons/lu";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LinkItem = ({ id, title, url, thumb, linkKey }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copiado com sucesso!', { position: "bottom-center" });
    } catch (err) {
      toast.error('❌ Erro ao copiar o link!');
      console.error("Erro ao copiar:", err);
    }
  };
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: title,
        url: url,
      });
    } else {
      toast.warning('Compartilhamento não suportado no seu navegador.');
    }
    setShowMenu(false);
  };

  return (
    <div className="link-item">
      <img src={thumb} alt={title} className="link-thumb" />

      <div className="link-content">
        <a href={url} target="_blank" rel="noopener noreferrer" className="link-title">
          {title} #{linkKey}
        </a>
      </div>

      <div className="link-options" ref={menuRef}>
        <button onClick={handleCopyLink} className="options-button">
          <LuLink2 />
        </button>
      </div>
    </div>
  );
};

export default LinkItem;
